// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Loader_loadingContainer__pEl4c","loader":"Loader_loader__2M2jx","rotate":"Loader_rotate__1as5_","ball1":"Loader_ball1__3CInr","ball2":"Loader_ball2__1OJ1l"};